import { GlobalSendRecentTransactionsRequest, GlobalSendRecentTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchCrossBorderTransactions({ bearer }: { bearer?: string } = {}) {
  const [fetching, setFetching] = useState(false);
  const [transactions, setTransactions] = useState<GlobalSendRecentTransaction[]>([]);

  async function fetchTransactions(params: GlobalSendRecentTransactionsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchRecentGlobalSendTransactions(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setTransactions(res.Transactions);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, transactions, fetchTransactions };
}
